import { useMemo } from "react";

interface SanitizeMentionsProps {
  mentionedUsers: {
    id: any;
    display: any;
    color: any;
    name: any;
  }[];
}

const useSanitizeMentions = ({ mentionedUsers }: SanitizeMentionsProps) => {
  const sanitizedMentionData = useMemo(
    () =>
      mentionedUsers
        .filter((user) => user && (user.name || user.display))
        .map((user) => ({
          id: String(user.id),
          display: (user.name || user.display || "").toString(),
          color: user.color || "#ccc",
        })),
    [mentionedUsers]
  );

  return sanitizedMentionData;
};

export default useSanitizeMentions;
